import type { Focus } from '../utilities/calculateActiveIndex'
import type { MenuItemDataRef } from './Item'

export type Actions =
  | { type: ActionTypes.CloseAll }
  | { type: ActionTypes.CloseMenu; external?: boolean }
  | { type: ActionTypes.CloseSubmenu }
  | { type: ActionTypes.OpenMenu }
  | { type: ActionTypes.OpenSubmenu; id: string }
  | { type: ActionTypes.GoToItem; focus: Focus.Specific; id: string }
  | { type: ActionTypes.GoToItem; focus: Exclude<Focus, Focus.Specific> }
  | { type: ActionTypes.SelectItem; id: string; keepShow?: boolean }
  | { type: ActionTypes.RefreshSelectedIndex }
  | { type: ActionTypes.Search; value: string }
  | { type: ActionTypes.ClearSearch }
  | { type: ActionTypes.RegisterItem; id: string; dataRef: MenuItemDataRef }
  | { type: ActionTypes.UnregisterItem; id: string }
  | { type: ActionTypes.UnregisterNotifyAction }
  | { type: ActionTypes.RegisterMultiSelect }
  | { type: ActionTypes.RegisterSelect }

export enum ActionTypes {
  CloseAll,

  OpenMenu,
  CloseMenu,

  OpenSubmenu,
  CloseSubmenu,

  GoToItem,
  SelectItem,
  RefreshSelectedIndex,
  Search,
  ClearSearch,

  RegisterItem,
  UnregisterItem,

  UnregisterNotifyAction,

  RegisterMultiSelect,
  RegisterSelect,
}
